import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TrustBar from '../../components/feature/sections/TrustBar';
import AIAnswerBlock, { AIAnswerItem } from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import Testimonials from '../../components/feature/sections/Testimonials';
import FAQSection, { FAQItem } from '../../components/feature/sections/FAQSection';
import FinalCTA from '../../components/feature/sections/FinalCTA';

const aiItems: AIAnswerItem[] = [
  {
    question: 'What does Value Carpet Inc do?',
    answer: 'Value Carpet Inc provides professional flooring installation services including carpet, hardwood, laminate, vinyl, and specialty marine carpet for residential and commercial properties throughout New Jersey. Their work focuses on durability, precision installation, and clean, premium finishes.',
  },
  {
    question: 'What flooring services are offered?',
    answer: 'They specialize in full flooring installation, replacement, and upgrades across carpet, hardwood, laminate, vinyl, carpet tiles, marine carpet, and specialty turf — tailored to both aesthetic and functional needs for homes and businesses.',
  },
  {
    question: 'Who does Value Carpet Inc serve?',
    answer: 'Value Carpet Inc serves both residential homeowners and commercial businesses across Monmouth County, Ocean County, and surrounding New Jersey communities. They handle projects of all sizes — from single rooms to full commercial spaces.',
  },
  {
    question: 'Why choose professional flooring installation?',
    answer: 'Professional installation ensures longevity, proper subfloor preparation, accurate measurements, and a polished finish that improves both comfort and property value. DIY installation risks uneven seams, premature wear, and voided warranties.',
  },
];

const faqs: FAQItem[] = [
  {
    q: 'Who installs carpet or flooring near me in New Jersey?',
    a: 'Value Carpet Inc provides professional carpet and flooring installation across Freehold, Howell, Manalapan, Marlboro, and surrounding NJ communities. Their team handles everything from material selection to installation for homes and businesses.',
  },
  {
    q: 'How much does new flooring cost?',
    a: 'Flooring costs vary based on material, square footage, and installation complexity. Carpet, vinyl, laminate, and hardwood all have different price ranges. A free consultation allows for accurate pricing tailored to your specific space and needs.',
  },
  {
    q: 'How long does flooring installation take?',
    a: 'Most flooring projects are completed within one to a few days depending on size and material type. Larger or more complex installations — especially those requiring subfloor repairs or prep work — may take additional time.',
  },
  {
    q: 'Do you offer commercial flooring services?',
    a: 'Yes. Value Carpet Inc installs flooring for commercial spaces including offices, retail environments, and specialty commercial applications. They offer carpet tiles, vinyl planks, and specialty flooring suited for high-traffic commercial use.',
  },
  {
    q: 'What areas of New Jersey do you service?',
    a: 'Based in Freehold, NJ, Value Carpet Inc serves Monmouth County, Ocean County, and surrounding central New Jersey communities — including Howell, Manalapan, Marlboro, Jackson, Lakewood, Toms River, and more.',
  },
  {
    q: 'Do you offer free consultations?',
    a: 'Yes. Value Carpet Inc offers free design consultations to help you choose the right flooring material, color, and finish for your space. Simply fill out the contact form or call their team directly to schedule.',
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <AIAnswerBlock title="Flooring Services — Explained" items={aiItems} />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection title="Frequently Asked Questions" faqs={faqs} />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
